import { getHistory } from "@claroty/utilities/store/history";
import { Logger } from "@claroty/utilities/tracking/errorReporting";
import { trackPageView } from "@claroty/utilities/tracking/manualTracking";
import * as Sentry from "@sentry/react";

let g_lastPageTitle = undefined,
    g_lastPathname = undefined;
export function onPageView() {
    const pathname = getHistory().location.pathname;
    if (g_lastPathname === pathname) return;

    const pageElement = document.querySelector("[data-t-page]");
    const newPageTitle = pageElement ? pageElement.getAttribute("data-t-page") : `<UNNAMED: ${pathname}>`;
    trackPageView(newPageTitle, g_lastPageTitle, pageElement);
    setSentryPageTags(pathname, newPageTitle);

    g_lastPageTitle = newPageTitle;
    g_lastPathname = pathname;
}

function setSentryPageTags(pathname: string, pageName: string) {
    try {
        Sentry.setTag("pathname", pathname);
        Sentry.setTag("page_name", pageName);
    } catch (e) {
        Logger.error("setSentryPageTags", "Failed to set Sentry page tags", { message: e.message });
    }
}
